"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var OrderModule = /** @class */ (function (_super) {
    __extends(OrderModule, _super);
    function OrderModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 发送文字短信
     * @param content 短信内容
     * @param operator 操作人
     * @param phone 接收短信手机号
     * @param token
     */
    OrderModule.prototype.sendSMS = function (content, phone, operator, token) {
        return this.gatewayClient.sentText('OMS', content, operator, phone, 1, token);
    };
    /**
     * 查询oms发送短信的记录
     * @param startTime 查询开始时间
     * @param endTime 查询结束时间
     * @param keyword 关键字
     * @param phone 手机号码
     * @param page
     * @param size
     * @param token
     */
    OrderModule.prototype.querySMSRecords = function (startTime, endTime, keyword, phone, page, size, token) {
        return this.gatewayClient.smsRecords(startTime, endTime, keyword, phone, page, size, token);
    };
    /**
     * 修改子入住单对账单状态
     * @param id 对账单id
     * @param operator 操作人
     * @param remark 备注
     * @param state 状态（type=1时 1未对账 2已对账 3异常）（type=2时 1未收款 2已收款 3异常）
     * @param type 类型
     * @param token
     */
    OrderModule.prototype.updateCheckinInfoCheckState = function (id, operator, remark, state, type, token) {
        return this.gatewayClient.updateCheckinInfoCheckState(id, operator, remark, state, type, token);
    };
    /**
     * 修改支付单对账单状态
     * @param id 对账单id
     * @param operator 操作人
     * @param remark 备注
     * @param state 状态（type=1时 1未对账 2已对账 3异常）（type=2时 1未收款 2已收款 3异常）
     * @param type 类型
     * @param token
     */
    OrderModule.prototype.updatePayInfoCheckState = function (id, operator, remark, state, type, token) {
        return this.gatewayClient.updatePayInfoCheckState(id, operator, remark, state, type, token);
    };
    /**
     * 修改线下收款状态
     * @param id 记录id
     * @param operator 操作人
     * @param receiveWay 收款渠道
     * @param remark 备注
     * @param state 确认状态： 1 待确认 2 已确认 3 作废
     * @param token
     */
    OrderModule.prototype.updateConfirmPayState = function (id, operator, receiveWay, remark, state, token) {
        return this.gatewayClient.confirmPayState(id, operator, receiveWay, remark, state, token);
    };
    /**
     * 支付单项目列表
     * @param startDate 创建开始时间
     * @param endDate	创建结束时间
     * @param page 页数
     * @param size 页大小
     * @param order 订单号
     * @param payName 支付人姓名
     * @param payNo 支付单号
     * @param payWay 支付类型 1-ota渠道订单支付 2-wechat 微信 3-unionpay 银联 4-makeup 代客代付 5-alipay 支付宝支付 6-system 下单即支付成功 7-银联（线下） 8-支付宝（线下） 9-微信（线下） 10-现金（线下） 11-其他（线下）
     * @param project 项目 1-房费 2-押金 3-增值服务 4-旧数据迁移 5-超时支付成功
     * @param source 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     *
     * @param token
     */
    OrderModule.prototype.queryPayList = function (params, token) {
        return this.gatewayClient.payList(params, token);
    };
    /**
     * 查看子入住单密码
     * @param checkinInfoId
     */
    OrderModule.prototype.getOpenPwd = function (checkinInfoId, token) {
        return this.gatewayClient.getOpenPwd(checkinInfoId, token);
    };
    /**
     * 根据入住单查询订单详情
     * @param checkinId
     */
    OrderModule.prototype.checkinDetailByCheckinId = function (checkinId, token) {
        return this.gatewayClient.checkinDetailByCheckinId(checkinId, token);
    };
    /**
     * 查询子入住单报表
     * @param page 页数
     * @param size 页大小
     * @param accountState 对账状态 1-未对账 2-已对账 3-异常
     * @param beginCheckinTime 起始入住日期
     * @param endCheckinTime 结束入住时间
     * @param beginCheckoutTime 起始退房时间
     * @param endCheckoutTime 结束退房时间
     * @param orderNo 订单号
     * @param orderSource 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param otaNo OTA单号
     * @param phone 预订手机
     * @param receiptState 收款状态
     * @param token
     */
    OrderModule.prototype.queryListCheckinInfoReport = function (params, token) {
        return this.gatewayClient.listCheckinInfoReport(params, token);
    };
    /**
     * 查询子入住单状态明细
     * @param id 对账单id
     * @param token
     */
    OrderModule.prototype.queryListCheckinInfoDetailInfo = function (id, token) {
        return this.gatewayClient.listCheckinInfoDetailInfo(id, token);
    };
    /**
     * 查询对账收款导入记录
     * @param startDate 开始时间
     * @param endDate 结束时间
     * @param page 页码
     * @param size 页大小
     * @param token
     */
    OrderModule.prototype.queryListCheckResult = function (params, token) {
        return this.gatewayClient.listCheckResult(params, token);
    };
    /**
     * 查询支付单报表
     * @param params
     * @param startDate 支付开始日期
     * @param endDate 支付结束日期
     * @param page 页码
     * @param size 页大小
     * @param accountState 对账状态 1-未对账 2-已对账 3-异常
     * @param orderNo 订单号
     * @param orderSource 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param otaNo OTA单号
     * @param payNo 支付单号
     * @param payType 支付方式 1 ota渠道订单支付 2 wechat 微信 3 unionpay 银联 4 makeup 代客代付 5 alipay 支付宝支付 6 system 下单即支付成功 7 银联（线下） 8 支付宝（线下） 9 微信（线下） 10 现金（线下） 11 其他（线下）
     * @param receiptState 收款状态 1未收款 2已收款 3异常
     * @param settlementNo 结算单号
     * @param token
     */
    OrderModule.prototype.queryListPayInfoReport = function (params, token) {
        return this.gatewayClient.listPayInfoReport(params, token);
    };
    /**
     * 查询支付单状态明细
     * @param id 对账单id
     */
    OrderModule.prototype.queryListPayInfoDetailInfo = function (id, token) {
        return this.gatewayClient.listPayInfoDetailInfo(id, token);
    };
    /**
     * 查询线下支付确认收款表
     * @param params
     * @param page 页码
     * @param size 页大小
     * @param startDate 支付开始时间
     * @param endDate 支付结束时间
     * @param orderNo 订单号
     * @param orderSource 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param payNo 支付单号
     * @param payWay 支付方式 1 ota ota渠道订单支付 2 wechat 微信 3 unionpay 银联 4 makeup 代客代付 5 alipay 支付宝支付 6 system 下单即支付成功 7 7 银联（线下） 8 8 支付宝（线下） 9 9 微信（线下） 10 10 现金（线下） 11 11 其他（线下）
     * @param status 确认状态：1待确认 2已确认 3作废
     * @param token
     */
    OrderModule.prototype.queryListOfflinePayment = function (params, token) {
        return this.gatewayClient.listOfflinePayment(params, token);
    };
    /**
     * 查询订单统计报表
     * @param params
     * @param page 页码
     * @param size 页大小
     * @param startDate 创建开始时间
     * @param endDate 创建结束时间
     * @param name 预订人姓名
     * @param orderNo 订单号
     * @param otherNo 渠道单号
     * @param phone 手机号
     * @param source 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param status 订单进度 1未开始 2进行中 3已结束 4取消
     * @param token
     */
    OrderModule.prototype.queryOrderReport = function (params, token) {
        return this.gatewayClient.orderReport(params, token);
    };
    OrderModule.prototype.payWithBarCode = function (barCode, operator, orderNo, payType, token) {
        function getPayTypeNumber(type) {
            var mapper = {
                wechat: 2,
                union: 3,
                alipay: 5
            };
            return mapper[type];
        }
        return this.gatewayClient.barcodePay(barCode, operator, orderNo, getPayTypeNumber(payType), token);
    };
    /**
     * 停用单列表查询接口
     * @param chainId 门店ID
     * @param city 城市名
     * @param endDate 创建结束时间
     * @param hotspotId 热点ID
     * @param hotspotPowerIds 热点权限范围
     * @param page 当前页
     * @param roomIdOrNo 房间ID或者房间号
     * @param size 每页大小
     * @param startDate 创建开始时间
     * @param stat 停用单状态  0-新建 1-开始 2-结束 3-停用取消(已开始) 4-未开始取消
     * @param stopEndDate 停用预结束时间
     * @param stopNo 停用单号
     * @param stopStartDate 停用预开始时间
     * @param type 停用单类型 1-待解约停用 2-设施维修停用 3-长租房停用 4-参观停用 5-预订停用 6-其它原因
     * @param token
     */
    OrderModule.prototype.queryStopList = function (params, token) {
        return this.gatewayClient.stopList(params, token);
    };
    /**
     * 取消停用单接口
     * @param stopId 停用单ID
     * @param token
     */
    OrderModule.prototype.removeStopItem = function (stopId, token) {
        return this.gatewayClient.stopCancel(stopId, token);
    };
    /**
     * 前台下单接口
     * @param activityId 指定执行活动id,不选择任何活动请传递 -1
     * @param arrivalTime 预计到店时间
     * @param bargainMoney 押金金额
     * @param beginDate	订单开始时间
     * @param cardCode 使用卡券code
     * @param channelCommission 渠道佣金
     * @param discount 折扣金额
     * @param discountId 优惠Id
     * @param endDate 订单结束时间
     * @param invoicePrice 发票金额
     * @param name 下单时填写的用户称呼
     * @param orderPrice 订单总价
     * @param otherChannelExpenses 渠道其他费用
     * @param otherNo 渠道订单号
     * @param realPrice 订单应付
     * @param receivedPrice 实收
     * @param remark 备注
     * @param rentType 租房类型 1-短租，2-长租
     * @param roomIds 多个房间用数组逗号隔开
     * @param roomTypeId 房型id
     * @param source 订单来源
     * @param userId 下单人ID
     * @param userPay 实付
     * @param xdollar 使用xdollar数量
     */
    OrderModule.prototype.placeFrontOrder = function (params, token) {
        return this.gatewayClient.frontDestOrder(params, token);
    };
    /**
     * 获取优惠类型
     * @param type 	优惠类型分类	number	可选值: 1:代下单优惠类型(默认); 2:前台下单类型;
     */
    OrderModule.prototype.getDiscountType = function (type, token) {
        return this.gatewayClient.getDiscountType(type, token);
    };
    /**
     * 下单接口
     * @param activityId 指定执行活动id,不选择任何活动请传递 -1
     * @param arrivalTime 预计到店时间
     * @param bargainMoney 押金金额
     * @param beginDate	订单开始时间
     * @param cardCode 使用卡券code
     * @param channelCommission 渠道佣金
     * @param discount 折扣金额
     * @param discountId 优惠Id
     * @param endDate 订单结束时间
     * @param invoicePrice 发票金额
     * @param name 下单时填写的用户称呼
     * @param orderPrice 订单总价
     * @param otherChannelExpenses 渠道其他费用
     * @param otherNo 渠道订单号
     * @param realPrice 订单应付
     * @param receivedPrice 实收
     * @param remark 备注
     * @param rentType 租房类型 1-短租，2-长租
     * @param roomIds 多个房间用数组逗号隔开
     * @param roomTypeId 房型id
     * @param source 订单来源
     * @param userId 下单人ID
     * @param userPay 实付
     * @param xdollar 使用xdollar数量
     */
    OrderModule.prototype.placeOrder = function (params, token) {
        return this.gatewayClient.bookOrder(params, token);
    };
    /**
     * 查询可预订房间
     * @param beginDate 开始时间
     * @param chainId	门店ID
     * @param city 城市名
     * @param custRoomName 房间名
     * @param custRoomNo	房间号
     * @param endDate	结束时间
     * @param hotspotId	热点ID
     * @param hotspotPowerIds	热点权限范围
     * @param page 页码
     * @param roomIds	房间ID数组
     * @param roomTypeName 房型名称
     * @param size 每页大小
     * @param tag	标签条件
     */
    OrderModule.prototype.queryAvailableRooms = function (params, token) {
        return this.gatewayClient.omsCanOrderRoom(params, token);
    };
    /**
     * 查询房间押金
     * @param roomId 房间ID
     * @param token
     */
    OrderModule.prototype.queryRoomGuarantee = function (roomId, token) {
        return this.gatewayClient.roomGuarantee(roomId, token);
    };
    /**
     * 模糊查询子标签
     * @param cnameWay 标签全路径
     * @param tagCode 标签码
     * @param valueCount
     * @param token
     */
    OrderModule.prototype.querySubTag = function (params, token) {
        return this.gatewayClient.getSubTag(params, token);
    };
    /**
     * 计算实收价格
     * @param activityId 活动ID
     * @param beginDate 订房开始时间
     * @param endDate 订房结束时间
     * @param roomIds 房间ID数组
     * @param source 订单来源ID
     */
    OrderModule.prototype.queryFinalPrice = function (params, token) {
        return this.gatewayClient.calculatePrice(params, token);
    };
    /**
     * 查询房间价格
     * @param beginDateTime 开始时间
     * @param endDateTime 结束时间
     * @param orderCheckinTime 订单预入住时间
     * @param roomId 房间ID
     * @param stat 状态
     * @param token
     */
    OrderModule.prototype.queryRoomsPrice = function (params, token) {
        return this.gatewayClient.calculateNormalInfo(params, token);
    };
    /**
     * 查询丽家会清洁布草报表
     *
     *  @param hotspotName 热点Id（根据需求这里可以是热点Id或者热点名称）
     *  @param rows 每页查询数量（分页）
     *  @param roomName 房间名称
     *  @param  city 城市名
     *  @param queryStartDate 结束日期（***必传***）
     *  @param chainName 门店Id（根据需求这里可以是门店Id或者门店名称）
     *  @param page 页码（分页）
     *  @param queryEndDate 开始日期（***必传***）
     *  @param province 省份名
     *  @param  roomId 房间Id
     *  @param  ownerName 业主姓名
     */
    OrderModule.prototype.getCleanLinenReport = function (params, token) {
        return this.gatewayClient.getCleanLinenReport(params, token);
    };
    /**
     * 查询丽家会易耗品报表
     *
     *  @param ownerName 业主姓名
     *  @param roomId 房间Id
     *  @param queryStartDate 结束日期（***必传***）
     *  @param hotspotId 热点Id（根据需求这里可以是热点Id或者热点名称）
     *  @param page 页码（分页）
     *  @param roomName 房间名称
     *  @param province 省份
     *  @param chainName 门店Id（根据需求这里可以是门店Id或者门店名称）
     *  @param queryEndDate 开始日期（***必传***）
     *  @param rows 每页查询数（分页）
     *  @param city 城市
     */
    OrderModule.prototype.getBillRoomConsumables = function (params, token) {
        return this.gatewayClient.getBillRoomConsumables(params, token);
    };
    /**
     * 查询丽家会易耗品城市列表
     *
     *  @param provinceName 省份名
     */
    OrderModule.prototype.queryCityList = function (provinceName, token) {
        return this.gatewayClient.queryCleanCityList(provinceName, token);
    };
    /**
     * 查询丽家会易耗品省份列表
     *
     */
    OrderModule.prototype.queryProvinceList = function (token) {
        return this.gatewayClient.queryCleanProvinceList(token);
    };
    /**
     * 查询丽家会易耗品门店列表
     *
     *  @param provinceName 省份名
     *  @param cityName 城市名
     */
    OrderModule.prototype.queryChainList = function (params, token) {
        return this.gatewayClient.queryChainList(params, token);
    };
    /**
     * 查询丽家会易耗品热点列表
     *
     * @param provinceName 省份名
     * @param cityName 城市名
     */
    OrderModule.prototype.queryHotspotList = function (params, token) {
        return this.gatewayClient.queryHotspotList(params, token);
    };
    /**
     * 发票管理 -> 冲红发票
     * @param id
     * @param reason 冲红理由
     * @param omsAccount
     * @param token
     */
    OrderModule.prototype.revokeElectronicInvoice = function (id, omsAccount, reason, token) {
        return this.gatewayClient.elecInvoiceRevoke(id, omsAccount, reason, token);
    };
    /**
     * 发票管理 -> 取消发票
     * @param id
     * @param omsAccount oms账号
     * @param remark 备注
     */
    OrderModule.prototype.cancelInvoice = function (id, omsAccount, remark, token) {
        return this.gatewayClient.cancelInvoice(id, omsAccount, remark, token);
    };
    /**
     * 发票管理 -> 更新快递
     * @param express
     * @param expressFee
     * @param expressNo
     * @param expressState
     * @param invoiceNo
     * @param type
     * @param token
     */
    OrderModule.prototype.updateInvoiceExpress = function (params, token) {
        return this.gatewayClient.updateInvoiceExpress(params, token);
    };
    /**
     * 发票管理 -> 更新状态
     * @param id
     * @param token
     */
    OrderModule.prototype.updateElecInvoiceState = function (id, token) {
        return this.gatewayClient.updateElecInvoiceState(id, token);
    };
    /**
     * 发票管理 -> 查询
     * @param startDate
     * @param endDate
     * @param size
     * @param page
     * @param source 1 - 用户；2 - OMS
     * @param orderNo
     * @param invoiceType 1-纸质；2-电子
     * @param paperState 发票状态
     * @param elecState 开票状态
     * @param title 发票抬头
     * @param invoiceNo 发票号码
     * @param invoiceInfo 收票信息
     * @param token
     */
    OrderModule.prototype.queryInvoiceList = function (params, token) {
        return this.gatewayClient.includeElecInvoice(params, token);
    };
    /**
     * 发票管理 -> 补充备注
     * @param id
     * @param omsAccount
     * @param remark
     * @param token
     */
    OrderModule.prototype.appendInvoiceRemark = function (id, omsAccount, remark, token) {
        return this.gatewayClient.appendInvoiceRemark(id, omsAccount, remark, token);
    };
    /**
     * 发票管理 -> 重发邮件
     * @param id
     * @param email 重发邮件的邮箱
     * @param token
     */
    OrderModule.prototype.resendElecInvoiceByEmail = function (id, email, token) {
        return this.gatewayClient.resendElecInvoiceByEmail(id, email, token);
    };
    /**
     * 订单开票管理开具发票
     * @param account oms账号
     * @param address 收件人地址
     * @param applyName 申请人姓名
     * @param applyPhone 申请人手机号
     * @param city 城市code
     * @param cityName 城市名
     * @param county 区县code
     * @param countyName 区县名
     * @param email email
     * @param expressFee 快递费
     * @param invoiceMoney 发票金额
     * @param invoiceNo 发票号码
     * @param invoiceType 发票类型：1纸质 2电子
     * @param orderNo 开票订单
     * @param orderPrice 订单金额
     * @param phone 手机号码
     * @param price 开票金额
     * @param province 省code
     * @param provinceName 省名
     * @param realMoney 实付
     * @param realname 实付人
     * @param remark 备注
     * @param taxpayerId 税号
     * @param title 发票抬头
     * @param titleType 发票新增抬头类型：1-个人；2-企业
     * @param type 发票类型。1-增值税普通发票，2-增值税专用发票
     * @param userId 用户id
     * @param token
     */
    OrderModule.prototype.addInvoice = function (params, token) {
        return this.gatewayClient.addInvoice(params, token);
    };
    /**
     *
     * @param callDateBegin 呼入开始时间
     * @param callDateEnd 呼入结束时间
     * @param callType 1呼入2呼出
     * @param content 评价内容
     * @param createdDate 创建时间
     * @param customerAreaCode 区号
     * @param endDate 挂机时间
     * @param evaluateDate 评价时间
     * @param evaluateType 评价状态，1未评2已评价
     * @param id
     * @param noType 客户电话1固话2手机
     * @param pageSize 每页显示多少条
     * @param phone 客户电话
     * @param seatNo 座席号
     * @param smsType 短信发送状态1成功0失败/未发送
     * @param startRow 第几页
     * @param subId
     * @param talkType 通话状态，1成功0失败
     * @param uniqueId
     * @param token
     */
    OrderModule.prototype.queryEvaluateList = function (params, token) {
        return this.gatewayClient.queryEvaluateList(params, token);
    };
    /**
     * 查询短租退款单列表
     * @param endDate
     * @param orderNo
     * @param page
     * @param refundStat
     * @param size
     * @param startDate
     */
    OrderModule.prototype.queryShortRentList = function (params, token) {
        return this.gatewayClient.queryShortRentList(params, token);
    };
    /**
     * 提交退款信息
     * @param deductionImgList
     * @param deductionList
     * @param deductionMoneyList
     * @param id
     * @param operator
     * @param remark
     */
    OrderModule.prototype.subRefundInfo = function (params, token) {
        return this.gatewayClient.subRefundInfo(params, token);
    };
    /**
     * 手动退款
     * @param activeMoney
     * @param bankName
     * @param receiveAccount
     * @param id
     * @param receiveSource
     * @param refundChannel
     * @param sourceId
     * @param userName
     * @param remark
     */
    OrderModule.prototype.refundByHand = function (params, token) {
        return this.gatewayClient.refundByHand(params, token);
    };
    /**
     * 判断是否可申请在住清洁
     * @param checkinId 入住单Id
     * @param orderNo 订单号
     * @param token
     */
    OrderModule.prototype.checkinClean = function (checkinId, orderNo, token) {
        return this.gatewayClient.checkinClean(checkinId, orderNo, token);
    };
    /* 删除入住人
     * @param id
     * @param infoId
     * @param orderNo
     * @param token
     */
    OrderModule.prototype.delCheckiner = function (id, infoId, orderNo, token) {
        return this.gatewayClient.delCheckiner(id, infoId, orderNo, token);
    };
    /**
     * 添加入住人
     * @param checkinId
     * @param phone
     * @param userName
     * @param token
     */
    OrderModule.prototype.addCheckiner = function (checkinId, phone, userName, token) {
        return this.gatewayClient.addCheckiner(checkinId, phone, userName, token);
    };
    /**
     * 获取有效的账务
     * @param checkinId
     * @param page
     * @param pageSize
     * @param token
     */
    OrderModule.prototype.getUnfinishConsumptions = function (checkinId, page, size, token) {
        return this.gatewayClient.getUnfinishConsumptions(checkinId, page, size, token);
    };
    /**
     * oms-调整单列表
     * @param adjustmentResultId
     * @param audit
     * @param checkinId
     * @param checkinInfoId
     * @param createEnd
     * @param createStart
     * @param orderNo
     * @param page
     * @param size
     * @param token
     */
    OrderModule.prototype.getAdjustmentList = function (params, token) {
        return this.gatewayClient.getAdjustmentList(params, token);
    };
    /**
     * oms-调整单详情
     * @param adjustmentResultId
     * @param token
     */
    OrderModule.prototype.getAdjustmentDetail = function (params, token) {
        return this.gatewayClient.getAdjustmentDetail(params, token);
    };
    /**
     * oms-调整单复核
     * @param adjustmentResultId
     * @param operator
     * @param reviewNote
     * @param reviewState
     * @param token
     */
    OrderModule.prototype.getAdjustmentReview = function (params, token) {
        return this.gatewayClient.getAdjustmentReview(params, token);
    };
    /**
     * oms-调整单审批
     * @param adjustmentResultId
     * @param approvalNote
     * @param approvalState
     * @param operator
     * @param token
     */
    OrderModule.prototype.getAdjustmentApproval = function (params, token) {
        return this.gatewayClient.getAdjustmentApproval(params, token);
    };
    /**
     * oms-新增调整单-根据订单订单号查询入住单
     * @param orderNo
     * @param token
     */
    OrderModule.prototype.AddAdjustmentOrderNo = function (params, token) {
        return this.gatewayClient.AddAdjustmentOrderNo(params, token);
    };
    /**
     * oms-新增调整单-根据入住单查询子入住单
     * @param checkinId
     * @param token
     */
    OrderModule.prototype.AddAdjustmentListByCheckinId = function (params, token) {
        return this.gatewayClient.AddAdjustmentListByCheckinId(params, token);
    };
    /**
     * oms-新增调整单-调整单-查询账务
     * @param checkinId 入住单id
     * @param checkinInfoId 子入住单id
     * @param orderNo 订单号
     * @param token
     */
    OrderModule.prototype.AddAdjustmentListInfo = function (params, token) {
        return this.gatewayClient.AddAdjustmentListInfo(params, token);
    };
    /**
     * oms-新增调整单
     * @param actualCheckinTime
     * @param actualCheckoutTime
     * @param channelCommission
     * @param channelCommissionDiff
     * @param checkinId
     * @param checkinInfoId
     * @param createName
     * @param orderNo
     * @param orgActualCheckinTime
     * @param orgActualCheckoutTime
     * @param orgChannelCommission
     * @param orgCreateName
     * @param orgOtherChannelExpenses
     * @param orgOwnerBear
     * @param orgOwnerPromotionExpense
     * @param orgPlatformPrice
     * @param orgPromotionExpenseBack
     * @param orgReceivedPrice
     * @param orgRoomPrice
     * @param orgSettlementPrice
     * @param orgShouldPay
     * @param orgUpdateName
     * @param orgXbedBear
     * @param orgXbedPromotionExpense
     * @param otherChannelExpenses
     * @param otherChannelExpensesDiff
     * @param ownerBear
     * @param ownerBearDiff
     * @param ownerPromotionExpense
     * @param ownerPromotionExpenseDiff
     * @param platformPrice
     * @param platformPriceDiff
     * @param promotionExpenseBack
     * @param promotionExpenseBackDiff
     * @param reason
     * @param receivedPrice
     * @param receivedPriceDiff
     * @param roomId
     * @param roomNightDiff
     * @param roomPrice
     * @param roomPriceDiff
     * @param settlementPrice
     * @param settlementPriceDiff
     * @param shouldPay
     * @param shouldPayDiff
     * @param updateName
     * @param xbedBear
     * @param xbedBearDiff
     * @param xbedPromotionExpense
     * @param xbedPromotionExpenseDiff
     * @param token
     */
    OrderModule.prototype.addAdjustmentList = function (params, token) {
        return this.gatewayClient.addAdjustmentList(params, token);
    };
    /**
     * order-api
     * @param params
     * @param method
     * @param token
     */
    OrderModule.prototype.orderApi = function (params, method, token) {
        return this.gatewayClient.orderApi(params, method, token);
    };
    return OrderModule;
}(gateway_module_1.GatewayModule));
exports.OrderModule = OrderModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9vcmRlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFFQSxvREFBa0Q7QUFFbEQ7SUFBaUMsK0JBQWE7SUFBOUM7O0lBeTRDQSxDQUFDO0lBeDRDQzs7Ozs7O09BTUc7SUFDSSw2QkFBTyxHQUFkLFVBQ0UsT0FBZSxFQUNmLEtBQWEsRUFDYixRQUFnQixFQUNoQixLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsUUFBUSxDQUNoQyxLQUFLLEVBQ0wsT0FBTyxFQUNQLFFBQVEsRUFDUixLQUFLLEVBQ0wsQ0FBQyxFQUNELEtBQUssQ0FDTixDQUFDO0lBQ0osQ0FBQztJQUVEOzs7Ozs7Ozs7T0FTRztJQUNJLHFDQUFlLEdBQXRCLFVBQ0UsU0FBaUIsRUFDakIsT0FBZSxFQUNmLE9BQWUsRUFDZixLQUFhLEVBQ2IsSUFBWSxFQUNaLElBQVksRUFDWixLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsVUFBVSxDQUNsQyxTQUFTLEVBQ1QsT0FBTyxFQUNQLE9BQU8sRUFDUCxLQUFLLEVBQ0wsSUFBSSxFQUNKLElBQUksRUFDSixLQUFLLENBQ04sQ0FBQztJQUNKLENBQUM7SUFFRDs7Ozs7Ozs7T0FRRztJQUNJLGlEQUEyQixHQUFsQyxVQUNFLEVBQVUsRUFDVixRQUFnQixFQUNoQixNQUFjLEVBQ2QsS0FBYSxFQUNiLElBQVksRUFDWixLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsMkJBQTJCLENBQ25ELEVBQUUsRUFDRixRQUFRLEVBQ1IsTUFBTSxFQUNOLEtBQUssRUFDTCxJQUFJLEVBQ0osS0FBSyxDQUNOLENBQUM7SUFDSixDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFDSSw2Q0FBdUIsR0FBOUIsVUFDRSxFQUFVLEVBQ1YsUUFBZ0IsRUFDaEIsTUFBYyxFQUNkLEtBQWEsRUFDYixJQUFZLEVBQ1osS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHVCQUF1QixDQUMvQyxFQUFFLEVBQ0YsUUFBUSxFQUNSLE1BQU0sRUFDTixLQUFLLEVBQ0wsSUFBSSxFQUNKLEtBQUssQ0FDTixDQUFDO0lBQ0osQ0FBQztJQUVEOzs7Ozs7OztPQVFHO0lBQ0ksMkNBQXFCLEdBQTVCLFVBQ0UsRUFBVSxFQUNWLFFBQWdCLEVBQ2hCLFVBQWtCLEVBQ2xCLE1BQWMsRUFDZCxLQUFhLEVBQ2IsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGVBQWUsQ0FDdkMsRUFBRSxFQUNGLFFBQVEsRUFDUixVQUFVLEVBQ1YsTUFBTSxFQUNOLEtBQUssRUFDTCxLQUFLLENBQ04sQ0FBQztJQUNKLENBQUM7SUFFRDs7Ozs7Ozs7Ozs7Ozs7T0FjRztJQUNJLGtDQUFZLEdBQW5CLFVBQ0UsTUFXQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxPQUFPLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ25ELENBQUM7SUFFRDs7O09BR0c7SUFDSSxnQ0FBVSxHQUFqQixVQUFrQixhQUFxQixFQUFFLEtBQWE7UUFDcEQsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsVUFBVSxDQUFDLGFBQWEsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM3RCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksOENBQXdCLEdBQS9CLFVBQWdDLFNBQWlCLEVBQUUsS0FBYTtRQUM5RCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyx3QkFBd0IsQ0FBQyxTQUFTLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDdkUsQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7Ozs7T0FlRztJQUNJLGdEQUEwQixHQUFqQyxVQUNFLE1BYUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMscUJBQXFCLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2pFLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksb0RBQThCLEdBQXJDLFVBQXNDLEVBQVUsRUFBRSxLQUFhO1FBQzdELE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHlCQUF5QixDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNqRSxDQUFDO0lBRUQ7Ozs7Ozs7T0FPRztJQUNJLDBDQUFvQixHQUEzQixVQUNFLE1BTUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsZUFBZSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUMzRCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7T0FnQkc7SUFDSSw0Q0FBc0IsR0FBN0IsVUFDRSxNQWFDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGlCQUFpQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM3RCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksZ0RBQTBCLEdBQWpDLFVBQWtDLEVBQVUsRUFBRSxLQUFhO1FBQ3pELE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHFCQUFxQixDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM3RCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7T0FhRztJQUNJLDZDQUF1QixHQUE5QixVQUNFLE1BVUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsa0JBQWtCLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzlELENBQUM7SUFFRDs7Ozs7Ozs7Ozs7Ozs7T0FjRztJQUNJLHNDQUFnQixHQUF2QixVQUNFLE1BV0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsV0FBVyxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN2RCxDQUFDO0lBRU0sb0NBQWMsR0FBckIsVUFDRSxPQUFlLEVBQ2YsUUFBZ0IsRUFDaEIsT0FBZSxFQUNmLE9BQWUsRUFDZixLQUFhO1FBRWIsMEJBQTBCLElBQVk7WUFDcEMsSUFBTSxNQUFNLEdBQVE7Z0JBQ2xCLE1BQU0sRUFBRSxDQUFDO2dCQUNULEtBQUssRUFBRSxDQUFDO2dCQUNSLE1BQU0sRUFBRSxDQUFDO2FBQ1YsQ0FBQztZQUNGLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDdEIsQ0FBQztRQUVELE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFVBQVUsQ0FDbEMsT0FBTyxFQUNQLFFBQVEsRUFDUixPQUFPLEVBQ1AsZ0JBQWdCLENBQUMsT0FBTyxDQUFDLEVBQ3pCLEtBQUssQ0FDTixDQUFDO0lBQ0osQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7Ozs7OztPQWlCRztJQUNJLG1DQUFhLEdBQXBCLFVBQ0UsTUFlQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3BELENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksb0NBQWMsR0FBckIsVUFBc0IsTUFBYyxFQUFFLEtBQWE7UUFDakQsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsVUFBVSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN0RCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O09BMEJHO0lBQ0kscUNBQWUsR0FBdEIsVUFDRSxNQXlCQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxjQUFjLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzFELENBQUM7SUFFRDs7O09BR0c7SUFDSSxxQ0FBZSxHQUF0QixVQUF1QixJQUFZLEVBQUUsS0FBYTtRQUNoRCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxlQUFlLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3pELENBQUM7SUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7T0EwQkc7SUFDSSxnQ0FBVSxHQUFqQixVQUNFLE1BeUJDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDckQsQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7Ozs7T0FlRztJQUNJLHlDQUFtQixHQUExQixVQUNFLE1BY0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsZUFBZSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUMzRCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLHdDQUFrQixHQUF6QixVQUEwQixNQUFjLEVBQUUsS0FBYTtRQUNyRCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxhQUFhLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3pELENBQUM7SUFFRDs7Ozs7O09BTUc7SUFDSSxpQ0FBVyxHQUFsQixVQUNFLE1BSUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNyRCxDQUFDO0lBRUQ7Ozs7Ozs7T0FPRztJQUNJLHFDQUFlLEdBQXRCLFVBQ0UsTUFNQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxjQUFjLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzFELENBQUM7SUFFRDs7Ozs7Ozs7T0FRRztJQUNJLHFDQUFlLEdBQXRCLFVBQ0UsTUFNQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxtQkFBbUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDL0QsQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7OztPQWNHO0lBQ0kseUNBQW1CLEdBQTFCLFVBQ0UsTUFZQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxtQkFBbUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDL0QsQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7OztPQWNHO0lBQ0ksNENBQXNCLEdBQTdCLFVBQ0UsTUFZQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxzQkFBc0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDbEUsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxtQ0FBYSxHQUFwQixVQUFxQixZQUFvQixFQUFFLEtBQWE7UUFDdEQsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsa0JBQWtCLENBQUMsWUFBWSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3BFLENBQUM7SUFFRDs7O09BR0c7SUFDSSx1Q0FBaUIsR0FBeEIsVUFBeUIsS0FBYTtRQUNwQyxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxzQkFBc0IsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMxRCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxvQ0FBYyxHQUFyQixVQUNFLE1BR0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsY0FBYyxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUMxRCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxzQ0FBZ0IsR0FBdkIsVUFDRSxNQUdDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGdCQUFnQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM1RCxDQUFDO0lBRUQ7Ozs7OztPQU1HO0lBQ0ksNkNBQXVCLEdBQTlCLFVBQ0UsRUFBVSxFQUNWLFVBQWtCLEVBQ2xCLE1BQWMsRUFDZCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsaUJBQWlCLENBQUMsRUFBRSxFQUFFLFVBQVUsRUFBRSxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDN0UsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksbUNBQWEsR0FBcEIsVUFDRSxFQUFVLEVBQ1YsVUFBa0IsRUFDbEIsTUFBYyxFQUNkLEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxhQUFhLENBQUMsRUFBRSxFQUFFLFVBQVUsRUFBRSxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDekUsQ0FBQztJQUVEOzs7Ozs7Ozs7T0FTRztJQUNJLDBDQUFvQixHQUEzQixVQUNFLE1BT0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2hFLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksNENBQXNCLEdBQTdCLFVBQThCLEVBQVUsRUFBRSxLQUFhO1FBQ3JELE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHNCQUFzQixDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM5RCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7OztPQWVHO0lBQ0ksc0NBQWdCLEdBQXZCLFVBQ0UsTUFhQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxrQkFBa0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDOUQsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLHlDQUFtQixHQUExQixVQUNFLEVBQVUsRUFDVixVQUFrQixFQUNsQixNQUFjLEVBQ2QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLG1CQUFtQixDQUMzQyxFQUFFLEVBQ0YsVUFBVSxFQUNWLE1BQU0sRUFDTixLQUFLLENBQ04sQ0FBQztJQUNKLENBQUM7SUFFRDs7Ozs7T0FLRztJQUNJLDhDQUF3QixHQUEvQixVQUFnQyxFQUFVLEVBQUUsS0FBYSxFQUFFLEtBQWE7UUFDdEUsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsd0JBQXdCLENBQUMsRUFBRSxFQUFFLEtBQUssRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN2RSxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztPQThCRztJQUNJLGdDQUFVLEdBQWpCLFVBQ0UsTUE0QkMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsVUFBVSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN0RCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7T0FzQkc7SUFDSSx1Q0FBaUIsR0FBeEIsVUFDRSxNQW9CQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxpQkFBaUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDN0QsQ0FBQztJQUVEOzs7Ozs7OztPQVFHO0lBQ0ksd0NBQWtCLEdBQXpCLFVBQ0UsTUFPQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxrQkFBa0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDOUQsQ0FBQztJQUVEOzs7Ozs7OztPQVFHO0lBQ0ksbUNBQWEsR0FBcEIsVUFDRSxNQU9DLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDekQsQ0FBQztJQUVEOzs7Ozs7Ozs7OztPQVdHO0lBQ0ksa0NBQVksR0FBbkIsVUFDRSxNQVVDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDeEQsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksa0NBQVksR0FBbkIsVUFBb0IsU0FBaUIsRUFBRSxPQUFlLEVBQUUsS0FBYTtRQUNuRSxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsU0FBUyxFQUFFLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNwRSxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxrQ0FBWSxHQUFuQixVQUNFLEVBQVUsRUFDVixNQUFjLEVBQ2QsT0FBZSxFQUNmLEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsRUFBRSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDckUsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLGtDQUFZLEdBQW5CLFVBQ0UsU0FBaUIsRUFDakIsS0FBYSxFQUNiLFFBQWdCLEVBQ2hCLEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsU0FBUyxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDNUUsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLDZDQUF1QixHQUE5QixVQUNFLFNBQWlCLEVBQ2pCLElBQVksRUFDWixJQUFZLEVBQ1osS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHVCQUF1QixDQUMvQyxTQUFTLEVBQ1QsSUFBSSxFQUNKLElBQUksRUFDSixLQUFLLENBQ04sQ0FBQztJQUNKLENBQUM7SUFDRDs7Ozs7Ozs7Ozs7O09BWUc7SUFDSSx1Q0FBaUIsR0FBeEIsVUFDRSxNQVVDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGlCQUFpQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM3RCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLHlDQUFtQixHQUExQixVQUNFLE1BRUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsbUJBQW1CLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQy9ELENBQUM7SUFFRDs7Ozs7OztPQU9HO0lBQ0kseUNBQW1CLEdBQTFCLFVBQ0UsTUFLQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxtQkFBbUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDL0QsQ0FBQztJQUVEOzs7Ozs7O09BT0c7SUFDSSwyQ0FBcUIsR0FBNUIsVUFDRSxNQUtDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHFCQUFxQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNqRSxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLDBDQUFvQixHQUEzQixVQUNFLE1BRUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2hFLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksa0RBQTRCLEdBQW5DLFVBQ0UsTUFFQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyw0QkFBNEIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDeEUsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLDJDQUFxQixHQUE1QixVQUNFLE1BSUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMscUJBQXFCLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2pFLENBQUM7SUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7T0FxREc7SUFDSSx1Q0FBaUIsR0FBeEIsVUFDRSxNQW1EQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxpQkFBaUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDN0QsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksOEJBQVEsR0FBZixVQUFnQixNQUFjLEVBQUUsTUFBYyxFQUFFLEtBQWE7UUFDM0QsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsUUFBUSxDQUFDLE1BQU0sRUFBRSxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDNUQsQ0FBQztJQUNILGtCQUFDO0FBQUQsQ0FBQyxBQXo0Q0QsQ0FBaUMsOEJBQWEsR0F5NEM3QztBQXo0Q1ksa0NBQVcifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/order/index.js
// module id = 211
// module chunks = 44